import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { PFIZER } from 'utils/constants/healtProviders';
import { useTranslation } from 'utils/modifiedTranslation';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import LANGUAGE, { pfizerLanguages } from 'components/AppTranslationWrapper/constants/language';
import { changeLanguage } from 'components/AppTranslationWrapper/action';
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow_left.svg';
import Form from '../Form';
import './LanguageMenu.css';

const languageFilters = {
  [PFIZER]: pfizerLanguages,
};

const options = [];

for (const lang in LANGUAGE) {
  options.push({
    value: lang,
    title: lang.toUpperCase(),
  });
}

const inputs = {
  lang: {
    type: 'radio',
    options,
  },
};

const LanguageMenu = ({ fullWidth }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { code: providerCode } = useProviderSpecificConfiguration();
  const setLanguage = (lang) => {
    dispatch(changeLanguage(lang));
  };
  const { lang } = useSelector((state) => ({
    lang: state?.main?.lang,
  }));

  const data = {
    lang,
  };

  if (providerCode && languageFilters[providerCode]) {
    const filteredLanguages = Object.keys(languageFilters[providerCode]);
    inputs.lang.options = inputs.lang.options.filter((language) => filteredLanguages.indexOf(language.value) !== -1);
  }

  return (
    <div className={`language-menu ${isOpen ? 'open' : ''}`}>
      {fullWidth
        ? (
          <div className="fullwidth-wrapper" onClick={() => { setIsOpen(!isOpen); }}>
            <div className="current">
              <div className="title-wrapper">
                <p>
                  {t('medical_profile.system_language')}
                  :
                </p>
                <span>{lang}</span>
              </div>
              <ArrowLeft />
            </div>
          </div>
        ) : (
          <div onClick={() => { setIsOpen(!isOpen); }}>
            <div className="current">
              <span>{lang}</span>
              {' '}
              <ArrowLeft />
            </div>
          </div>
        )}
      <div className="language-popup">
        <Form
          inputs={inputs}
          data={data}
          onChange={({ lang: nextLang }) => {
            setLanguage(nextLang);
            setIsOpen(false);
          }}
        />
      </div>
    </div>
  );
};

export default LanguageMenu;

LanguageMenu.propTypes = {
  fullWidth: PropTypes.bool,
};
